const INITIAL_STATE = {
  leituraAtual: null,
  historico: [],
  config: null,
  estatisticas: null,
  loading: false,
  error: null,
};

export default function pluviometroReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'PLUVIOMETRO_LEITURA_ATUAL_FETCHED':
      const leituraData = (action.payload && action.payload.data) || null;
      return {
        ...state,
        leituraAtual: leituraData,
        loading: false,
        error: null,
      };

    case 'PLUVIOMETRO_HISTORICO_FETCHED':
      const historicoData = (action.payload && action.payload.data && action.payload.data.dados) || [];
      return {
        ...state,
        historico: historicoData,
        loading: false,
        error: null,
      };

    case 'PLUVIOMETRO_CONFIG_FETCHED':
      return {
        ...state,
        config: (action.payload && action.payload.data) || null,
        loading: false,
        error: null,
      };

    case 'PLUVIOMETRO_CONFIG_UPDATED':
      return {
        ...state,
        loading: false,
        error: null,
      };

    case 'PLUVIOMETRO_ESTATISTICAS_FETCHED':
      return {
        ...state,
        estatisticas: (action.payload && action.payload.data) || null,
        loading: false,
        error: null,
      };

    case 'PLUVIOMETRO_LEITURA_SAVED':
      return {
        ...state,
        loading: false,
        error: null,
      };

    case 'PLUVIOMETRO_CLEAR_DATA':
      return INITIAL_STATE;

    case 'PLUVIOMETRO_LEITURA_ATUAL_FETCHED_PENDING':
    case 'PLUVIOMETRO_HISTORICO_FETCHED_PENDING':
    case 'PLUVIOMETRO_CONFIG_FETCHED_PENDING':
    case 'PLUVIOMETRO_CONFIG_UPDATED_PENDING':
    case 'PLUVIOMETRO_ESTATISTICAS_FETCHED_PENDING':
    case 'PLUVIOMETRO_LEITURA_SAVED_PENDING':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'PLUVIOMETRO_LEITURA_ATUAL_FETCHED_REJECTED':
    case 'PLUVIOMETRO_HISTORICO_FETCHED_REJECTED':
    case 'PLUVIOMETRO_CONFIG_FETCHED_REJECTED':
    case 'PLUVIOMETRO_CONFIG_UPDATED_REJECTED':
    case 'PLUVIOMETRO_ESTATISTICAS_FETCHED_REJECTED':
    case 'PLUVIOMETRO_LEITURA_SAVED_REJECTED':
      return {
        ...state,
        loading: false,
        error:
          (action.payload.response &&
            action.payload.response.data &&
            action.payload.response.data.errors &&
            action.payload.response.data.errors[0]) ||
          'Erro desconhecido',
      };

    default:
      return state;
  }
}
